import { api } from "./apiService";

export const FetchLeaveTypeByUser = async (serviceNo) => {
     const params = new URLSearchParams({
        p_empServiceNo : serviceNo
    });
    
    const url = `/EmpLeaveAllocation/GetEmpLeaveAllocation?${params.toString()}`;
    console.log("[Leave TYPE] Request URL:", url);
    console.log("[Leave TYPE] Params:", params.toString());

    try {
       
     const response = await api.post(url);
        console.log("[Leave TYPEs] Response received:", response);
        return response;
    } catch (error) {
        console.log("[LEAVE TYPE] Error fetching leave type -> ", error)
        throw error
    }
}